module.exports = __webpack_public_path__ + "img/uni-colours.4b461ce1.jpg";